export enum DepartmentEnum {
  IT = 1,
  CDM = 2,
  OPERATIONS = 3,
  MEDICAL_WRITING = 4,
  CORE_LAB = 5,
  BIO_STAT = 6,
  REGULATORY_WRITING = 7,
  PV = 8,
  QUALITY_ASSURANCE = 9,
  TRAINING_DEPARTMENT = 10,
  MANAGEMENT = 11
}
